export default __webpack_public_path__ + "static/media/fk.a83317fe.svg";